import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export class TeamMemberErrorResponse {
    isBuyerReassignRefusal() {
        return this.error.hasServerError([
            ServerError.BuyerSignatureSlotAlreadySigned,
            ServerError.BuyerAlreadyARecipient
        ]);
    }
    removeMessage(texts) {
        if (this.error.hasServerError(ServerError.BuyerSignatureSlotAlreadySigned)) {
            return texts.teamMember.removedMemberSignedPendingProposal();
        }
        if (this.error.hasServerError(ServerError.BuyerAlreadyARecipient)) {
            return texts.teamMember.colleagueAlreadyARecipient();
        }
        if (this.error.hasServerError(ServerError.DocusealUnavailable)) {
            return texts.relationship.signatureProviderUnavailable();
        }
        return null;
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
